import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";

const Indicator = ({ label, value }) => {
  // Determine the color based on the value
  const color =
    Number(value) > 0 ? "#1D9A7D" : Number(value) < 0 ? "#E53E3E" : "#FFB020";

  // Determine the outer container color based on the value
  const outerContainerColor =
    Number(value) > 0 ? "#EAFBF7" : Number(value) < 0 ? "#FEEFEE" : "#FFF7E3";

  // ensure value is not -0.0
  value = Number(value).toFixed(1);
  // If value is NaN, set it to 0.0
  if (isNaN(value)) {
    value = '0.0';
  }
  return (
    <View style={[styles.outerContainer]}>
      <View
        style={[
          styles.container,
          {
            backgroundColor: outerContainerColor,
          },
        ]}
      >
        <Text style={[styles.label, { color }]}>{label}</Text>
        <Text style={{ ...styles.value, color }}>{`${
          Number(value) > 0 ? "+" : ""
        }${value}%`}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: 6,
    borderRadius: 8,
    width: "auto",
    margin: 4,
  },
  label: {
    fontSize: 10,
    color: "#2A3039", // Text/1 color
    marginRight: 4,
    fontFamily: "Raleway",
    fontWeight: 600,
  },
  value: {
    fontSize: 10,
    fontFamily: "Raleway",
    fontWeight: 600,
  },
  outerContainer: {
    display: "flex",
    justifyContent: "flex-end",
    height: 46,
  },
});

export default Indicator;
